import { render, staticRenderFns } from "./judgeAccount.vue?vue&type=template&id=5b5ac95a&scoped=true"
import script from "./judgeAccount.vue?vue&type=script&lang=js"
export * from "./judgeAccount.vue?vue&type=script&lang=js"
import style0 from "./judgeAccount.vue?vue&type=style&index=0&id=5b5ac95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ac95a",
  null
  
)

export default component.exports